<template>
  <collapsable
    :collapsed="collapsed"
    :title="$t('entities.entity_responsibles.title')"
  >
    <section class="entity-responsibles px-3">
      <div v-if="!editing" class="mb-3">
        <div v-if="pharmacyResponsible">
          <label class="is-bold">{{ $t('entities.pharmacy_responsible') }}:</label>&nbsp;
          <span v-if="pharmacyResponsible">{{ pharmacyResponsible.name }}</span>
          <br>
        </div>
        <div v-if="pharmacyContact">
          <label class="is-bold">{{ $t('entities.pharmacy_contact') }}:</label>&nbsp;
          <span v-if="pharmacyContact">{{ pharmacyContact.name }}</span>
          <br>
        </div>
        <div v-if="seniorManager">
          <label class="is-bold">{{ $t('entityrequests.senior_manager') }}:</label>&nbsp;
          <span v-if="seniorManager">{{ seniorManager.name }}</span>
          <br>
        </div>
        <div v-if="manager">
          <label class="is-bold">{{ $t('entityrequests.manager') }}:</label>&nbsp;
          <span v-if="manager">{{ manager.name }}</span>
          <br>
        </div>
        <div v-if="consultant">
          <label class="is-bold">{{ $t('entityrequests.consultant') }}:</label>&nbsp;
          <span v-if="consultant">{{ consultant.name }}</span>
          <br>
        </div>
        <div v-if="gdprManager">
          <label class="is-bold">{{ $t('entityrequests.gdpr_manager') }}:</label>&nbsp;
          <span v-if="gdprManager">{{ gdprManager.name }}</span>
          <br>
        </div>

        <div v-if="customerSuccessManager && isFromEvollu">
          <label class="is-bold">{{ $t('entityrequests.customer_success_manager') }}:</label>
          <span>&ensp;{{ customerSuccessManager.name }}</span>
          <br>
        </div>
      </div>

      <div v-else class="mb-3">
        <form class="evollu-form">

          <div class="row">
            <div class="col-12 col-sm-6 col-lg-3">
              <label class="form-label">{{ $t('entities.pharmacy_responsible') }}:</label>
              <multiselect
                v-model="editingPharmacyResponsible"
                :options="availablePharmacyUsers"
                track-by="id"
                label="name"
                select-label=""
                selected-label=""
                deselect-label=""
                placeholder="---"
                :allow-empty="true"
                :multiple="false"
                :searchable="true"
              >
                <span slot="noResult">{{ $t('patients.noResults') }}</span>
              </multiselect>
            </div>

            <div class="col-12 col-sm-6 col-lg-3 offset-lg-1">
              <label class="form-label">{{ $t('entities.pharmacy_contact') }}:</label>
              <multiselect
                v-model="editingPharmacyContact"
                :options="availablePharmacyUsers"
                track-by="id"
                label="name"
                select-label=""
                selected-label=""
                deselect-label=""
                placeholder="---"
                :allow-empty="true"
                :multiple="false"
                :searchable="true"
              >
                <span slot="noResult">{{ $t('patients.noResults') }}</span>
              </multiselect>
            </div>

            <div class="col-12 col-sm-6 col-lg-3 offset-lg-1">
              <label class="form-label">{{ $t('entityrequests.senior_manager') }}:</label>
              <multiselect
                v-model="editingSeniorManager"
                :options="availableSeniorManagers"
                track-by="id"
                label="name"
                select-label=""
                selected-label=""
                deselect-label=""
                placeholder="---"
                :allow-empty="true"
                :multiple="false"
                :searchable="true"
              >
                <span slot="noResult">{{ $t('patients.noResults') }}</span>
              </multiselect>
            </div>
          </div>

          <div class="row">
            <div class="col-12 col-sm-6 col-lg-3">
              <label class="form-label">{{ $t('entityrequests.manager') }}:</label>
              <multiselect
                v-model="editingManager"
                :options="availableManagers"
                track-by="id"
                label="name"
                select-label=""
                selected-label=""
                deselect-label=""
                placeholder="---"
                :allow-empty="true"
                :multiple="false"
                :searchable="true"
              >
                <span slot="noResult">{{ $t('patients.noResults') }}</span>
              </multiselect>
            </div>

            <div class="col-12 col-sm-6 col-lg-3 offset-lg-1">
              <label class="form-label">{{ $t('entityrequests.consultant') }}:</label>
              <multiselect
                v-model="editingConsultant"
                :options="availableConsultants"
                track-by="id"
                label="name"
                select-label=""
                selected-label=""
                deselect-label=""
                placeholder="---"
                :allow-empty="true"
                :multiple="false"
                :searchable="true"
              >
                <span slot="noResult">{{ $t('patients.noResults') }}</span>
              </multiselect>
            </div>

            <div class="col-12 col-sm-6 col-lg-3 offset-lg-1">
              <label class="form-label">{{ $t('entityrequests.gdpr_manager') }}:</label>
              <multiselect
                v-model="editingGdprManager"
                :options="availablePharmacyUsers"
                track-by="id"
                label="name"
                select-label=""
                selected-label=""
                deselect-label=""
                placeholder="---"
                :allow-empty="true"
                :multiple="false"
                :searchable="true"
              >
                <span slot="noResult">{{ $t('patients.noResults') }}</span>
              </multiselect>
            </div>
          </div>

          <div class="row">
            <div v-if="isFromEvollu" class="col-12 col-sm-6 col-lg-3">
              <label class="form-label">{{ $t('entityrequests.customer_success_manager') }}:</label>
              <multiselect
                v-model="editingCustomerSuccessManager"
                :options="availableCustomerSuccessManager"
                track-by="id"
                label="name"
                select-label=""
                selected-label=""
                deselect-label=""
                placeholder="---"
                :allow-empty="true"
                :multiple="false"
                :searchable="true"
              >
                <span slot="noResult">{{ $t('patients.noResults') }}</span>
              </multiselect>
            </div>
          </div>

        </form>
      </div>

      <div class="d-flex justify-content-end">
        <va-button v-if="editing"
                   class="btn-cancel mr-5"
                   @click.prevent="cancelEditResponsibles">
          {{ $t('modals.buttons.cancel') }}
        </va-button>

        <va-button v-if="editing"
                   @click.prevent="saveResponsibles">
          {{ $t('modals.buttons.save') }}
        </va-button>

        <va-button v-if="!editing && isFromEvollu"
                   @click.prevent="editResponsibles">
          {{ $t('entities.responsibles.update_responsibles') }}
        </va-button>
      </div>
    </section>
  </collapsable>
</template>

<script>
import Multiselect from 'vue-multiselect'
import Collapsable from '@/components/common/Collapsable'
import IsFromEvolluMixin from '@/mixins/IsFromEvolluMixin'
import { EntityService, EntityResponsibleService } from '@/api/AuthService'
import EventBus from '@/utils/EventBus'

const PROFILES = {
  SENIOR_MANAGER: 3,
  MANAGER: 4,
  CONSULTANT: 5,
  PHARMACY_RESPONSIBLE: 10,
  PHARMACY_CONTACT: 10,
  GDPR_MANAGER: 14,
  CSM: 15,
}

export default {
  components: {
    Multiselect,
    Collapsable
  },
  mixins: [
    IsFromEvolluMixin
  ],
  props: {
    entity: {
      type: Object,
      required: true
    },
    collapsed: {
      type: Boolean,
      required: false
    }
  },
  data () {
    return {
      editing: false,
      responsibles: [],
      availableSeniorManagers: [],
      availableManagers: [],
      availableConsultants: [],
      availablePharmacyUsers: [],
      availableGdprManagers: [],
      availableCustomerSuccessManager: [],
      userProfile: null,
      consultant: null,
      manager: null,
      seniorManager: null,
      pharmacyResponsible: null,
      pharmacyContact: null,
      gdprManager: null,
      customerSuccessManager: null,
      editingSeniorManager: null,
      editingManager: null,
      editingConsultant: null,
      editingPharmacyResponsible: null,
      editingPharmacyContact: null,
      editingGdprManager: null,
      editingCustomerSuccessManager: null
    }
  },
  computed: {
    audiologyServer: function () {
      // TODO: deprecate this variable, use auth routes
      return process.env.VUE_APP_LEADS_URL
    }
  },
  created: function () {
    this.loadUserProfile()
    EventBus.$on(`ENTITY_USER_CREATED_${this.entity.id}`, () => {
      this.loadPharmacyUsers()
    })
  },
  methods: {
    loadResponsiblesOptions () {
      EntityResponsibleService.getResponsibleOptions(this.entity.id)
        .then(options => {
          this.availableSeniorManagers = options.seniorManagers
          this.availableManagers = options.managers
          this.availableConsultants = options.consultants
        })
        .catch(err => {
          console.log(err)
          this.showToast(this.$t('entities.entity_responsibles.error_load_responsible_options'), this.$store.state.errorToastOptions)
        })
    },
    loadResponsibles () {
      EntityResponsibleService.getEntityResponsibles(this.entity.id)
        .then(responsibles => {
          this.responsibles = responsibles
          this.responsibles.forEach(responsible => {
            switch (responsible.profile.id) {
            case PROFILES.SENIOR_MANAGER:
              this.seniorManager = responsible.responsible
              break
            case PROFILES.MANAGER:
              this.manager = responsible.responsible
              break
            case PROFILES.CONSULTANT:
              this.consultant = responsible.responsible
              break
            case PROFILES.PHARMACY_RESPONSIBLE:
              this.pharmacyResponsible = responsible.responsible
              break
            case PROFILES.PHARMACY_CONTACT:
              this.pharmacyContact = responsible.responsible
              break
            case PROFILES.GDPR_MANAGER:
              this.gdprManager = responsible.responsible
              break
            case PROFILES.CSM:
              this.customerSuccessManager = responsible.responsible
              break
            }
          })
        }).catch((error) => {
          console.log(error)
        })
    },
    editResponsibles () {
      if (this.userProfile) {
        if (this.userProfile.profile.type === 'Project Manager' || this.userProfile.profile.type === 'Project Manager Evollu') {
          this.availableSeniorManagers = this.userProfile.childrens
        }

        this.editingSeniorManager = this.seniorManager
        this.editingManager = this.manager
        this.editingConsultant = this.consultant
        this.editingPharmacyResponsible = this.pharmacyResponsible
        this.editingPharmacyContact = this.pharmacyContact
        this.editingGdprManager = this.gdprManager
        this.editingCustomerSuccessManager = this.customerSuccessManager

        this.editing = true
      } else {
        this.showToast(this.$t('entities.entity_responsibles.error_user_has_no_profile'), this.$store.state.errorToastOptions)
      }
    },
    cancelEditResponsibles () {
      this.editingSeniorManager = null
      this.editingManager = null
      this.editingConsultant = null
      this.editingPharmacyResponsible = null
      this.editingPharmacyContact = null
      this.editingGdprManager = null
      this.editingCustomerSuccessManager = null
      this.editing = false
    },
    loadUserProfile: function () {
      this.$http({
        url: this.audiologyServer + '/users/' + this.$auth.user().id + '/profile'
      }).then((response) => {
        this.userProfile = response.data.data
      }).catch((error) => {
        console.log(error)
      })
    },
    /* regionalManagerSelected (option) {
      if (this.editingConsultant) this.editingConsultant = null
      if (this.editingAreaManager) this.editingAreaManager = null
      this.availableConsultants = []
      this.$http({
        url: this.audiologyServer + '/users/' + option.id + '/profile',
        params: { childs: true }
      }).then((response) => {
        this.availableAreaManagers = response.data.data
      }).catch((error) => {
        console.log(error)
      })
    },
    areaManagerChanged (option) {
      if (option === null) {
        this.availableConsultants = []
      }
    },
    areaManagerSelected (option) {
      if (this.editingConsultant) this.editingConsultant = null
      this.$http({
        url: this.audiologyServer + '/users/' + option.id + '/profile',
        params: { childs: true }
      }).then((response) => {
        this.availableConsultants = response.data.data
      }).catch((error) => {
        console.log(error)
      })
    }, */
    loadPharmacyUsers () {
      EntityService.getUsers(this.entity.id)
        .then(users => {
          this.availablePharmacyUsers = users
        }).catch((error) => {
          console.log(error)
        })
    },
    loadCustomerSuccessManager () {
      EntityService.getUsers(1)
        .then(csms => {
          this.availableCustomerSuccessManager = csms
        }).catch((error) => {
          console.log(error)
        })
    },
    saveResponsibles () {
      /* if (this.editingRegionalManager === null) {
        this.showToast(this.$t('users.errors.invalid_regional_manager'), this.$store.state.errorToastOptions)
        return
      }
      if (this.editingAreaManager === null) {
        this.showToast(this.$t('users.errors.invalid_area_manager'), this.$store.state.errorToastOptions)
        return
      }
      if (this.editingPharmacyResponsible === null) {
        this.showToast(this.$t('users.errors.invalid_pharmacy_user'), this.$store.state.errorToastOptions)
        return
      }
      if (this.editingPharmacyContact === null) {
        this.showToast(this.$t('users.errors.invalid_pharmacy_contact'), this.$store.state.errorToastOptions)
      } */

      let responsibleUsersIds = []

      /* if (this.hasChangedResponsible(this.editingRegionalManager, this.regionalManager)) {
        //promises.push(this.saveEntityResponsible(3, this.editingRegionalManager.id))
        responsibleUsersIds.push({
          profile_id: 3,
          responsible_user_id: this.editingRegionalManager.id
        })
      }
      if (this.hasChangedResponsible(this.editingAreaManager, this.areaManager)) {
        //promises.push(this.saveEntityResponsible(4, this.editingAreaManager.id))
        responsibleUsersIds.push({
          profile_id: 4,
          responsible_user_id: this.editingAreaManager.id
        })
      }
      if (this.hasChangedResponsible(this.editingConsultant, this.consultant)) {
        //promises.push(this.saveEntityResponsible(5, this.editingConsultant ? this.editingConsultant.id : null))
        responsibleUsersIds.push({
          profile_id: 5,
          responsible_user_id: this.editingConsultant.id
        })
      }
      if (this.hasChangedResponsible(this.editingPharmacyResponsible, this.pharmacyResponsible)) {
        //promises.push(this.saveEntityResponsible(10, this.editingPharmacyResponsible.id))
        responsibleUsersIds.push({
          profile_id: 10,
          responsible_user_id: this.editingPharmacyResponsible.id
        })
      }
      if (this.hasChangedResponsible(this.editingPharmacyContact, this.pharmacyContact)) {
        //promises.push(this.saveEntityResponsible(11, this.editingPharmacyContact.id))
        responsibleUsersIds.push({
          profile_id: 11,
          responsible_user_id: this.editingPharmacyContact.id
        })
      } */

      responsibleUsersIds.push(
        {
          profile_id: PROFILES.SENIOR_MANAGER,
          responsible_user_id: this.editingSeniorManager ? this.editingSeniorManager.id : null
        },
        {
          profile_id: PROFILES.MANAGER,
          responsible_user_id: this.editingManager ? this.editingManager.id : null
        },
        {
          profile_id: PROFILES.CONSULTANT,
          responsible_user_id: this.editingConsultant ? this.editingConsultant.id : null
        },
        {
          profile_id: PROFILES.PHARMACY_RESPONSIBLE,
          responsible_user_id: this.editingPharmacyResponsible ? this.editingPharmacyResponsible.id : null
        },
        {
          profile_id: PROFILES.PHARMACY_CONTACT,
          responsible_user_id: this.editingPharmacyContact ? this.editingPharmacyContact.id : null
        },
        {
          profile_id: PROFILES.GDPR_MANAGER,
          responsible_user_id: this.editingGdprManager ? this.editingGdprManager.id : null
        },
        {
          profile_id: PROFILES.CSM,
          responsible_user_id: this.editingCustomerSuccessManager ? this.editingCustomerSuccessManager.id : null
        }
      )

      EntityResponsibleService.updateResponsibles(this.entity.id, {
        responsible_users_ids: responsibleUsersIds
      }).then(() => {
        this.seniorManager = this.editingSeniorManager
        this.manager = this.editingManager
        this.consultant = this.editingConsultant
        this.pharmacyResponsible = this.editingPharmacyResponsible
        this.pharmacyContact = this.editingPharmacyContact
        this.gdprManager = this.editingGdprManager
        this.customerSuccessManager = this.editingCustomerSuccessManager
        this.showToast(this.$t('entities.messages.edit_responsibles_success'), this.$store.state.successToastOptions)
        EventBus.$emit(`ENTITY_RESPONSIBLE_USERS_UPDATED_${this.entity.id}`)
        this.cancelEditResponsibles()
      }).catch((error) => {
        this.showToast(this.$t('entities.messages.error'))
        this.error = error.response.data.errors[0].msg
      })
    },
    hasChangedResponsible (newResponsible, oldResponsible) {
      if (newResponsible === null && oldResponsible === null) {
        return false
      }
      if (newResponsible && oldResponsible && newResponsible.id === oldResponsible.id) {
        return false
      }
      if (newResponsible && oldResponsible === null) {
        return true
      }
      if (newResponsible === null && oldResponsible) {
        return true
      }
      if (newResponsible && oldResponsible && newResponsible.id !== oldResponsible.id) {
        return true
      }
    },
    resetResponsibles: function () {
      this.seniorManager = null
      this.manager = null
      this.consultant = null
      this.pharmacyResponsible = null
      this.pharmacyContact = null
      this.gdprManager = null
      this.customerSuccessManager = null
    },
    saveEntityResponsible (profileId, responsibleUserId) {
      return EntityResponsibleService.updateResponsible(this.entity.id, profileId, {
        responsible_user_id: responsibleUserId
      })
    }
  },
  watch: {
    entity: {
      handler: function (value) {
        this.resetResponsibles()
        this.cancelEditResponsibles()
        if (value) {
          this.loadResponsibles()
          this.loadPharmacyUsers()
          this.loadCustomerSuccessManager()
          this.loadResponsiblesOptions()
        }
      },
      immediate: true
    },
  }
}
</script>
